var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30.001px",
    height: "25px",
    viewBox: "0 0 30.001 25",
    enableBackground: "new 0 0 30.001 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M30.001,2.96c-1.103,0.501-2.287,0.841-3.533,0.992c1.269-0.779,2.247-2.014,2.706-3.492 c-1.188,0.725-2.51,1.251-3.907,1.536C24.144,0.766,22.543,0,20.771,0c-3.398,0-6.155,2.826-6.155,6.311 c0,0.495,0.059,0.975,0.162,1.439C9.662,7.49,5.129,4.975,2.09,1.153C1.561,2.085,1.257,3.173,1.257,4.33 c0,2.188,1.088,4.116,2.739,5.254C2.987,9.55,2.037,9.265,1.206,8.79c0,0.027,0,0.055,0,0.083c0,3.054,2.124,5.607,4.939,6.188 c-0.518,0.143-1.061,0.219-1.624,0.219c-0.395,0-0.78-0.037-1.155-0.112c0.78,2.509,3.053,4.333,5.746,4.384 c-2.105,1.693-4.759,2.702-7.641,2.702c-0.499,0-0.989-0.03-1.471-0.089C2.727,23.953,5.961,25,9.437,25 C20.759,25,26.95,15.383,26.95,7.042c0-0.271-0.007-0.546-0.02-0.817C28.132,5.336,29.178,4.224,30.001,2.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.516446c278bd0fe710a3cba61c103cec.svg";
export { ForwardRef as ReactComponent };